import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";

import { deleteUserPaymentAccount } from "app/api/payment_accounts";
import parseError from "app/lib/parseError";
import { useToast } from "app/providers/ToastProvider";
import { BaseResponse } from "app/api/types";

export default function useDeletePaymentAccount(id: string) {
  const toast = useToast();
  const queryClient = useQueryClient();

  const handleError = (err: AxiosError<any>) => {
    const errorMessage = parseError(err) as string;
    toast("", errorMessage, "error");
  };

  const handleSuccess = (res: AxiosResponse<BaseResponse>) => {
    queryClient.invalidateQueries(["payment_accounts", "payment-accounts"]);
    toast("", res.data.message || "Payment account deleted", "success");
  };

  const { isLoading, data, mutate, error } = useMutation(
    ["delete-account", id],
    () => deleteUserPaymentAccount(id),
    {
      onError: handleError,
      onSuccess: handleSuccess,
    }
  );

  return {
    isLoading,
    data: data?.data,
    deleteAccount: mutate,
    error: error ? (parseError(error as AxiosError<{}>) as string) : undefined,
  };
}
